import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function LeadDialog({ trigger, program = "", source = "website", title = "Talk to an Admissions Counselor" }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ name: "", email: "", phone: "", age_category: "", message: "" });
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/leads", { ...form, program, interest: program, source });
            toast.success("Thank you! An admissions counselor will reach out shortly.");
            setOpen(false);
            setForm({ name: "", email: "", phone: "", age_category: "", message: "" });
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{trigger}</DialogTrigger>
            <DialogContent className="sm:max-w-md" data-testid="lead-dialog">
                <DialogHeader>
                    <DialogTitle className="font-heading">{title}</DialogTitle>
                    <DialogDescription>
                        {program ? `Enquire about ${program}.` : "Tell us a little about yourself and your goals."}
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={submit} className="space-y-3">
                    <div>
                        <Label htmlFor="lead-name">Full name</Label>
                        <Input id="lead-name" data-testid="lead-name-input" required value={form.name} onChange={set("name")} className="mt-1.5" />
                    </div>
                    <div>
                        <Label htmlFor="lead-email">Email</Label>
                        <Input id="lead-email" type="email" data-testid="lead-email-input" required value={form.email} onChange={set("email")} className="mt-1.5" />
                    </div>
                    <div>
                        <Label htmlFor="lead-phone">Phone</Label>
                        <Input id="lead-phone" data-testid="lead-phone-input" value={form.phone} onChange={set("phone")} className="mt-1.5" />
                    </div>
                    <div>
                        <Label htmlFor="lead-msg">What would you like to learn?</Label>
                        <Textarea id="lead-msg" data-testid="lead-message-input" value={form.message} onChange={set("message")} className="mt-1.5" rows={3} />
                    </div>
                    <Button type="submit" data-testid="lead-submit-btn" disabled={loading} className="w-full rounded-full">
                        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Submit Enquiry"}
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
}
